import React from 'react'
import { Link } from 'react-router-dom'
import { assets } from '../assets/assets'

const MyDonate = () => {
  return (
    <div>
       <div className="breadcrumb_sec">
        <div className="container">
            <nav>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to=''>My Account</Link>
                    </li>
                    <li className="breadcrumb-item">
                        My Donations
                    </li>
                </ol>
            </nav>
            <div className="support pb-3">
                <h3>My Donations</h3>
                <p>Track your generous contributions which transformed lives.</p>
            </div>
        </div>
    </div>


    <div className="my_doncation pt-5 pb-5">
        <div className="container">
            <div className="">
                <div className="my_donation_btn mb-3">
                    <div className="d-flex align-items-center justify-content-between justify-content-sm-start">
                        <div className="w_100 m-1">
                            <Link to='' className="btn btn-primary rounded-2 shadow-none">One Time
                                Donation</Link>
                        </div>
                        <div className="w_100 m-1"><Link to='' className="btn btn-warning">Monthly Subscription</Link></div>
                    </div>
                </div>
                <div className="row mb-4 d-flex align-items-center">
                    <div className="col-md-4 col-lg-7 mb-3 mb-md-0 text-center text-md-start title">All Donations</div>
                    <div className="col-md-8 col-lg-5">
                        <div className="row gy-4 gy-md-0">
                            <div className="col-6">
                                <div className="donate_card text-center px-1 py-2 p-sm-3 card h-100 border-0">
                                    <div className="icon"><img src={assets.bookmark_icon} alt="Donated Amounot"/>
                                    </div>
                                    <div className="price">₹0</div>
                                    <div className="name mt-auto">Donated Amount</div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="donate_card text-center px-1 py-2 p-sm-3 card h-100 border-0">
                                    <div className="icon"><img src={assets.calender_icon}
                                            alt="Donated Amounot"/></div>
                                    <div className="price">0</div>
                                    <div className="name mt-auto">Active Subscription</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom_table">
                    <div className="table-responsive">
                        <table className="table align-middle min_width">
                            <thead>
                            <tr>
                            <th style={{ width: '20%' }}>Name</th>
                            <th style={{ width: '20%' }}>Status</th>
                            <th style={{ width: '20%' }}>Donation Date</th>
                            <th style={{ width: '20%' }}>Amount</th>
                            <th style={{ width: '20%' }}>Action</th>
                          </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Donation 1</td>
                                    <td>Pending</td>
                                    <td>14-09-2024</td>
                                    <td>₹ 700</td>
                                    <td><Link  to ='' className="btn btn-primary rounded shadow-none">view details</Link></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>

    </div>
  )
}

export default MyDonate
